import schedule from '@devices/settings/device_settings/schedule.js';
import app_setting_gen_2_no_appliance from '@devices/settings/device_settings/app_setting_gen_2_no_appliance.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'Harvia RSS',
	friendly_name: 'Harvia RSS',
	family: 'relay',
	isPM: false,
	modes: {
		relay: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			settings: [
				schedule,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{ title: 'cloud', component: 'cloud' },
					],
				},
				app_setting_gen_2_no_appliance,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'power_on_default', component: 'power_on_default_rr' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
			hideFromIoActions: [
				'ext_hum_over_url',
				'ext_hum_under_url',
				'ext_temp_over_url',
				'ext_temp_under_url',
			],
		},
	},
};
